package store.actions

import it.neckar.common.redux.ChangeType
import store.LoggedInState
import store.PlannerClientState

data class LoggedInLoadedFromLocalStorageAction(val loadedLoggedInState: LoggedInState) : StateAction {
  override val type: ChangeType = ChangeType.HistoryReset

  override fun PlannerClientState.updateState(): PlannerClientState {
    return this.copy(loginState = loadedLoggedInState)
  }
}
